module.exports = __webpack_public_path__ + "static/media/features-img.ce6dc3e7.png";